/**
 * Appointments
 *
 * Description: This component displays a list of appointments for the user, allowing for filtering by appointment type (online/physical), status, and date range. It supports pagination and fetches appointment data based on selected filters. The component uses a custom table wrapper to present the appointment details with a link to view more information. The view adapts depending on whether the appointments are online or physical.
 *
 * File Name: Appointments.tsx
 * Date: 09-09-2024
 */

import React, { useEffect, useMemo, useState } from "react";
import PageHeader from "src/Components/Customer/PageHeader";
import { customer, doctor, doctorMode } from "src/lib/constans";
import Cookies from "js-cookie";
import MyOnlineAppointments from "src/Components/MyAppointments/MyOnlineAppointments";
import MyPhysicalAppointments from "src/Components/MyAppointments/MyPhysicalAppointments";
import MyHomecareAppointments from "src/Components/MyAppointments/MyHomecareAppointments";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { convertToKebabCase } from "src/helpers/helperFunctions";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import { IDropDownArray } from "src/types/GlobalInterfaces";
import { useNavigate, useSearchParams } from "react-router-dom";
type tabKeys = "online" | "physical" | "homecare";
interface IItem {
  title: string;
  display: boolean;
  key: tabKeys;
  count?: any;
}

const Appointments: React.FC = () => {
  const [mode] = useState(doctor);
  const { allIndicators } = useSelector(
    (store: RootState) => store?.redDots
  );
  const navigate = useNavigate();

  let [searchParams] = useSearchParams();
  let tab = searchParams.get("tab") || "";

  const tabList: IItem[] = [
    {
      title: "Online Appointments",
      display: true,
      key: "online",
      count:
        allIndicators?.doctorOnlineAppointment ||
        allIndicators?.customerOnlineAppointment,
    },
    {
      title: "In-Clinic Appointments",
      display: true,
      key: "physical",
      count:
        allIndicators?.doctorPhysicalAppointment ||
        allIndicators?.customerPhysicalAppointment,
    },
  ];


  const [activeTab, setActiveTab] = useState<tabKeys>(tab as tabKeys || "online");

  useEffect(() => {
    setActiveTab(tab as tabKeys || "online");
  }, [tab]);

  return (
    <>
      <PageHeader title="My Appointments" />
      <div
        style={{
          position: "relative",
          // minHeight: `calc(${
          //   document.getElementById("customer-sidebar-id")?.offsetHeight
          // }px - 1rem - ${document.getElementById("headerH")?.offsetHeight}px)`,
        }}
        className="parent-box parent-box-height parent-box-height-new-iss-res appoitment-filters"
      >
        <div className="flex gap-4 items-center justify-between">
          <div className="flex gap-4">
            {tabList
              .filter((v) => v.display)
              .map((item: IItem) => (
                <button
                  onClick={() => {
                    navigate(`?tab=${item.key}`);
                  }}
                  key={item.key}
                  id={`appointment-tab-${convertToKebabCase(item.title)}`}
                  className={`relative border font-size-15px font-Poppins-SemiBold health-tabs-main-btn rounded-full ${
                    activeTab === item.key
                      ? "text-[#fff] theme-bg-green"
                      : "theme-color-green border-[#004540]"
                  }`}
                >
                  {item.title}
                  {item.count > 0 && (
                    <div className="red-dot-show absolute -top-1 -right-1"></div>
                  )}
                </button>
              ))}
          </div>
        </div>
        <hr className="products-tabs-hr-allOrder" />
        {activeTab === "online" ? (
          <MyOnlineAppointments />
        ) : activeTab === "physical" ? (
          <MyPhysicalAppointments />
        ) : null}
      </div>
    </>
  );
};

export default Appointments;
